import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setPlanManagementReloadModalOpen,
  setShowReloadPlanManagement,
} from "../../../reducers/ownApp";
import { planManagementReloadModalOpenSelector } from "../../../reducers/ownApp/selectors";
import {
  getMatrixProfileType,
  getSelectedMatrixProfile,
} from "../../../reducers/matrixProfile/selectors";
import { fetchDepotRouteMatrix } from "../../../reducers/matrixProfile/thunkActions";

import { Modal } from "../Modal";
import { PlanManagementReloadContent } from "./PlanManagementReloadContent";
import { PlanManagementReloadActions } from "./PlanManagementReloadActions";

export const PlanManagementReloadModal = memo(() => {
  const dispatch = useDispatch();
  const open = useSelector(planManagementReloadModalOpenSelector);
  const type = useSelector(getMatrixProfileType);
  const profile = useSelector(getSelectedMatrixProfile);

  const onClose = () => {
    dispatch(setPlanManagementReloadModalOpen(false));
  };
  const onContinue = async () => {
    onClose();
    dispatch(setShowReloadPlanManagement(false));
    await dispatch(fetchDepotRouteMatrix({ type, profile }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={"Reload Plan"}
      content={<PlanManagementReloadContent />}
      actions={
        <PlanManagementReloadActions
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
});
